import axios from 'axios';
import host from '../global';
import Cookies from 'js-cookie';

const getAuthHeader = () => ({
  Authorization: `Bearer ${Cookies.get('accessToken')}`,
});

export const fetchRecruiterAnalyticsService = async (startDate = null, endDate = null) => {
  const response = await axios.get(`${host}/orgadmin/recruiter-analytics`, {
    headers: getAuthHeader(),
    params: {
      start_date: startDate || undefined,
      end_date: endDate || undefined,
    },
  });
  return response.data;
};

// TEMPORARY: hits the no-auth dummy endpoint for frontend testing. Remove
// alongside /orgadmin/recruiter-analytics-dummy once real data testing is done.
export const fetchRecruiterAnalyticsDummyService = async () => {
  const response = await axios.get(`${host}/orgadmin/recruiter-analytics-dummy`);
  return response.data;
};
